"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.preDestroy = void 0;
var metadata_1 = require("../class/metadata");
/** run method before destroy instance */
function preDestroy() {
    return function (target, key) {
        (0, metadata_1.getMetadata)(target.constructor).preDestroy.push({ key: key });
    };
}
exports.preDestroy = preDestroy;
//# sourceMappingURL=preDestroy.js.map